export default {"src":"/_next/static/media/map-pin-blue.4be68862.svg","height":37,"width":95};